import {rootPath} from '../configs/global';
import navaid from 'navaid';

export let Router = navaid(rootPath);
